import { TBrand } from './types';

const BRAND_REQUIRED_FIELD = [
  'vertical',
  'country',
  'principal_website',
  'name'
];

export const checkValidation = (brand?: TBrand): boolean => {
  return (
    !!brand &&
    BRAND_REQUIRED_FIELD.every((key) => key in brand) &&
    Object.values(brand).every((value) => !!value.length)
  );
};
